import { forwardRef } from 'react';
import type { HTMLAttributes } from 'react';
import './CornerTag.css';

export type Corner = 'tech' | 'phys' | 'psych' | 'social';

const GLYPH: Record<Corner, string> = {
  tech: '◆',
  phys: '◉',
  psych: '▲',
  social: '■',
};

const LABEL: Record<Corner, string> = {
  tech: 'tech',
  phys: 'phys',
  psych: 'psych',
  social: 'social',
};

interface CornerTagProps extends HTMLAttributes<HTMLSpanElement> {
  corner: Corner;
  label?: string;
  filled?: boolean;
}

export const CornerTag = forwardRef<HTMLSpanElement, CornerTagProps>(function CornerTag(
  { corner, label, filled = false, className = '', ...rest },
  ref
) {
  return (
    <span
      ref={ref}
      data-corner={corner}
      data-filled={filled || undefined}
      className={`corner-tag ${className}`.trim()}
      {...rest}
    >
      <span className="corner-tag__glyph" aria-hidden="true">{GLYPH[corner]}</span>
      <span className="corner-tag__label">{label ?? LABEL[corner]}</span>
    </span>
  );
});
